import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import { TableView } from "./tablePreferences";

/**
 * How much of a row you want to see, as three named choices.
 *
 * Icon-only and in the toolbar, matching the compact/spacious toggle Campaign
 * Stats already ships — the shape is a pattern the app has rather than a
 * new invention, and the toolbar is `space-between` with no wrapping, so three
 * labelled buttons would crowd out the search field and the Create button the
 * wider lists carry.
 */
const VIEWS: {
  value: TableView;
  label: string;
  hint: string;
  Icon: SvgIconComponent;
}[] = [
  {
    value: "compact",
    label: "Compact",
    hint: "Compact — one line per row, smaller type, most rows per screen",
    Icon: ViewCompactIcon,
  },
  {
    value: "full",
    label: "Full",
    hint: "Full — long names wrap instead of being cut, up to three lines",
    Icon: ViewStreamIcon,
  },
  {
    value: "fit",
    label: "Fit",
    hint: "Fit — columns size to their content and the table scrolls sideways",
    Icon: OpenInFullIcon,
  },
];

export default function TableViewToggle({
  value,
  onChange,
}: {
  value: TableView;
  onChange: (view: TableView) => void;
}) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      // `null` arrives when the pressed button is the one already selected.
      // Ignored rather than cleared: there is no fourth, unnamed layout to fall
      // back to, and a table with no view selected has nothing to render.
      onChange={(_, next) => next && onChange(next)}
    >
      {VIEWS.map(({ value: view, label, hint, Icon }) => (
        <ToggleButton key={view} value={view} aria-label={`${label} view`}>
          <Tooltip title={hint}>
            <Icon fontSize="small" />
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
